app.controller("SelectionIndexController", [
    "$scope", "Socket", "Selection", "StaticData", "SysParam", "$stateParams", "$state", "$http", "$uibModal", "usSpinnerService", "ConfirmModal", "toastr", "ProgramService", "GradeTemplate", "AuthService",
    function ($scope, Socket, Selection, StaticData, SysParam, $stateParams, $state, $http, $uibModal, usSpinnerService, ConfirmModal, toastr, ProgramService, GradeTemplate, AuthService) {
        $scope.query = $stateParams.query;
        $scope.gradeTemplate = $stateParams.gradeTemplate;
        $scope.canFilterByTemplate = AuthService.hasRight('manage-grade-templates');
        if ($scope.canFilterByTemplate) {
            GradeTemplate.list().then(function (templates) {
                $scope.gradeTemplates = templates;
            });
        }
        $scope.itemsPerPage = 25;
        $scope.totalItems = {};
        var now = new Date();
        $scope.years = _.range(2017, now.getFullYear() + 1);
        $scope.year = now.getFullYear().toString();
        $scope.season = now.getMonth() < 7 ? 'spring' : 'autumn';
        $scope.filterSeason = $stateParams.season;

        SysParam.getSysParam('currentSeason').then(function (param) {
            if (!$stateParams.season) $scope.filterSeason = param.value;
        });


        StaticData.getItemsByKey("subject_seasons").then(function (seasons) {
            $scope.seasons = [].concat(seasons);
            $scope.seasonsMap = _.keyBy($scope.seasons, '_id');

            $scope.filterSeasons = [];
            $scope.years.forEach(function (year) {
                $scope.seasons.forEach(function (season) {
                    $scope.filterSeasons.push({
                        _id: year + '-' + season._id,
                        name: year + ' ' + season.name
                    })
                })
            })
        });

        $scope.$watch('filterSeason', function (val) {
            if (val) {
                var strings = val.split('-');
                $scope.year = strings[0];
                $scope.season = strings[1];
            }
        }, true);



        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            Selection.list({
                season: $stateParams.season || $scope.filterSeason,
                page: page,
                query: $stateParams.query,
                program: $stateParams.program,
                gradeTemplate: $stateParams.gradeTemplate,
                limit: $scope.itemsPerPage
            }).then(function (data) {
                $scope.subjects = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }



        if ($stateParams.program) {
            usSpinnerService.spin("root");
            ProgramService.fetchOne($stateParams.program).then(function (program) {
                $scope.program = program;
                usSpinnerService.stop("root");
                loadPage($stateParams.page, function () {
                    $scope.currentPage = $stateParams.page;
                });
            });
        } else {
            loadPage($stateParams.page, function () {
                $scope.currentPage = $stateParams.page;
            });
        }

        $scope.submitQuery = function () {
            $state.go(".", {
                query: $scope.query,
                season: $scope.filterSeason,
                program: $scope.program ? $scope.program._id : undefined,
                gradeTemplate: $scope.gradeTemplate,
            });
        };

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            var params = {};
            params.query = name;
            return ProgramService.list(params).then(function (data) {
                return data.docs;
            });
        };

        $scope.view = function (activationId) {
            $state.go("admin.selection-details", {activationId: activationId});
        };

        $scope.edit = function (activationId) {
            $state.go("admin.selection-sessions", {activationId: activationId});
        };

        $scope.grades = function (activationId) {
            $state.go("admin.activation-grades", {activationId: activationId});
        };

        $scope.add = function () {
            $uibModal.open({
                controller: "AddActivationController",
                templateUrl: _pb + 'admin/selection/add-activation.html',
                size: "md",
                backdrop: 'static',
            }).result
                .then(function (result) {
                    $state.go(".");
                }, function () {
                });
        };

        $scope.deactivate = function (activationId) {
            ConfirmModal.show({
                title: "დეაქტივაცია",
                message: "ნამდვილად გსურთ ამ საგნის დეაქტივაცია? (ეს ქმედება ვერ შესრულდება, თუ საგანზე მიბმულია სესიის ჯგუფები)"
            }).result.then(function () {
                Selection.deactivateSubject({activation: activationId}).then(function (resp) {
                    toastr.success("საგანი დეატივირებულია.");
                    loadPage($stateParams.page);
                }).catch(function (err) {
                    console.error(err);
                    if (err.status === 400) {
                        toastr.error("საგანზე მიბმულია სესიის ჯგუფები!");
                    }
                })
            });
        };

        $scope.studentSelectionStates = function () {
            $state.go("admin.StudentsSelectionStates", {});
        };

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        // $scope.subjects = [];
        // var socket = new Socket('/selections');
        //
        // $scope.addSubject = function () {
        //     socket.emit('subject:select', {
        //         subject: Math.random().toString(36).substring(7)
        //     });
        // };
        //
        // socket.on('subject:unselect', function (subject) {
        //     $scope.subjects.push(subject);
        // });
    }
]);
